import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  NgxGalleryAnimation,
  NgxGalleryComponent,
  NgxGalleryImage,
  NgxGalleryImageSize,
  NgxGalleryLayout,
  NgxGalleryOptions,
  NgxGalleryOrder,
} from '@kolkov/ngx-gallery';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss'],
})
export class ImageCarouselComponent implements OnInit, OnChanges {
  @ViewChild('gallery') gallery: NgxGalleryComponent;

  @Input()
  resources: any[] = [];

  @Input()
  galleryOptions: NgxGalleryOptions[];

  galleryImages: NgxGalleryImage[] = [];

  constructor() {}

  ngOnInit() {
    if (!this.galleryOptions) {
      console.log('using default gallery options');
      this.galleryOptions = [
        {
          imageSize: NgxGalleryImageSize.Cover,
          thumbnailsColumns: 5,
          thumbnailsRows: 1,
          thumbnailsMargin: 2,
          thumbnailsOrder: NgxGalleryOrder.Row,
          thumbnailsRemainingCount: true,
          imageAnimation: NgxGalleryAnimation.Zoom,
          imageInfinityMove: true,
          previewAnimation: true,
          previewZoom: true,
          previewRotate: true,
          previewInfinityMove: true,
          imageArrowsAutoHide: false,
          thumbnailsArrows: false,
          thumbnailsArrowsAutoHide: false,
          imageSwipe: true,
          image: false,
          thumbnailsSwipe: true,
          previewSwipe: true,
          previewKeyboardNavigation: true,
          previewCloseOnEsc: true,
          thumbnailActions: [],
        },
        {
          breakpoint: 800,
          width: '100%',
          height: '200px',
          imagePercent: 80,
          thumbnailsPercent: 50,
          thumbnailsMargin: 20,
          thumbnailMargin: 20,
          thumbnailsColumns: 2,
        },
        {
          breakpoint: 400,
          thumbnailsArrowsAutoHide: false,
          thumbnailsColumns: 2,
          thumbnailsMoveSize: 2,
          thumbnailsRows: 10,
          height: '1000px',
          thumbnailsPercent: 40,
          imagePercent: 60,
          thumbnailMargin: 2,
          thumbnailsMargin: 2,
          thumbnailsOrder: 2,
        },
      ];
    } else {
      console.log('using passed gallery options', this.galleryOptions);
    }

    this.buildImageArrayForGallery();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildImageArrayForGallery();
  }

  /**
   * Since we have to wait until the image is deleted from the server,
   * we use the OnChanges hook to update the array after it's
   * immutably "spliced" in the parent.
   */
  buildImageArrayForGallery(): void {
    this.galleryImages = [];
    if (this.resources.length > 0) {
      this.resources.forEach((image) => {
        this.galleryImages.push({
          small: image.url,
          medium: image.url,
          big: image.url,
          label: image.url,
          description: image.url,
        });
      });
    }
  }
}
